import { render, staticRenderFns } from "./editFriend.vue?vue&type=template&id=671aea7f&scoped=true"
import script from "./editFriend.vue?vue&type=script&lang=js"
export * from "./editFriend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671aea7f",
  null
  
)

export default component.exports